
import Vue from 'vue';
import CategorySection from '../components-pc/CategorySection.vue';
import HomeFooter from '../components-pc/HomeFooter.vue';

export default Vue.extend({
  name: 'SignupPc',
  components: {
    CategorySection,
    HomeFooter,
  },
});
